import { gql } from '@apollo/client';

export const GET_LATEST_WAREHOUSE_ID_BY_DRIVER_ACCOUNT_ID_AND_DSP_ID = gql`
    query GetLatestWarehouseIdByDriverAccountIdAndDspId(
        $driverAccountId: Long!
        $dspId: Long!
    ) {
        getLatestWarehouseIdByDriverAccountIdAndDspId(
            driverAccountId: $driverAccountId
            dspId: $dspId
        )
    }
`;

export interface GetLatestWarehouseIdByDriverAccountIdAndDspIdResponse {
    getLatestWarehouseIdByDriverAccountIdAndDspId: number | null;
}

export interface GetLatestWarehouseIdByDriverAccountIdAndDspIdVariables {
    driverAccountId: number;
    dspId: number;
}

